import { get } from 'vio-libs';
export function getEdgeMarketsByOrg(organization, consumerAPI) {
    if (!consumerAPI) {
        return get(`edge-markets?organization=${organization}`);
    }
    return get(`v1/${organization}/markets`, undefined, true);
}
export function getEdgeMarkets(consumerAPI) {
    if (!consumerAPI) {
        return get('edge-markets');
    }
    return get('v1/markets', undefined, true);
}
